import StoresPanel from './StoresPanel';

export default StoresPanel;



// WEBPACK FOOTER //
// ./src/scenes/Stores/components/StoresPanel/index.ts